var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { forwardRef, useState, useEffect, useRef } from 'react';
import { questionCodeName } from '../../../../../src/shared/types/constants';
import { answerCodeName } from '../../../../../src/shared/types/constants';
import { services, tryParseNumber } from '../../../../shared';
import { useParams } from 'react-router-dom';
import { debounce } from 'lodash';
import { InputSelectProduct } from '../input-select-product/input-select-product';
export var InputProduct = forwardRef(function (_a, ref) {
    var id = _a.id, forceSelection = _a.forceSelection, legend = _a.legend, options = _a.options, required = _a.required, disabled = _a.disabled, error = _a.error, setValue = _a.setValue, value = _a.value, inputListChangeHandler = _a.inputListChangeHandler, watch = _a.watch, questionSet = _a.questionSet, productValue = _a.productValue;
    var _b = useParams(), caseId = _b.caseId, loanPurposeId = _b.loanPurposeId, formId = _b.formId;
    var _c = useState([]), items = _c[0], setItems = _c[1];
    var loanMonitor = useRef();
    var purchaseMonitor = useRef();
    var loanTermMonitor = useRef();
    var loanTermMonMonitor = useRef();
    var hasFilterQuestion = useRef(false);
    var targetCaseId = tryParseNumber(caseId);
    var targetFormId = tryParseNumber(formId);
    var targetLoanPurposeId = tryParseNumber(loanPurposeId);
    var productQuestion = questionSet === null || questionSet === void 0 ? void 0 : questionSet.questions.find(function (q) { return q.code == questionCodeName.productCode; });
    var displayOptions = options !== null && options !== void 0 ? options : [];
    var watchLoan;
    var watchPurchase;
    var watchLoanTerm;
    var watchLoanTermMon;
    var productFilters = useRef();
    productFilters.current = {
        purchasePrice: '',
        loanAmount: '',
        loanTerm: '',
        loanTermMon: '',
    };
    var setWatchValue = function (id, question) {
        var idPart = id.split('-');
        return watch("".concat(idPart[0], "-").concat(question.id, "-").concat(idPart[2]));
    };
    var hasFilterBeenUsed = function (loan, purchase, loanTerm, loanTermMon) {
        return (loan == productFilters.current.loanAmount &&
            purchase == productFilters.current.purchasePrice &&
            loanTerm == productFilters.current.loanTerm &&
            loanTermMon == productFilters.current.loanTermMon);
    };
    var createProductFilters = function (loan, purchase, loanTerm, loanTermMon) {
        return {
            loanAmount: "".concat(loan),
            purchasePrice: "".concat(purchase),
            loanTerm: "".concat(loanTerm),
            loanTermMon: "".concat(loanTermMon),
        };
    };
    var isDirty = function (monitorQuestion, watchValue) {
        var _a;
        return (monitorQuestion === null || monitorQuestion === void 0 ? void 0 : monitorQuestion.isPresent) && ((_a = monitorQuestion === null || monitorQuestion === void 0 ? void 0 : monitorQuestion.answer) === null || _a === void 0 ? void 0 : _a.value) !== watchValue;
    };
    var getAnswer = function (monitorQuestion, watchValue) {
        return !(monitorQuestion === null || monitorQuestion === void 0 ? void 0 : monitorQuestion.isPresent) &&
            (monitorQuestion === null || monitorQuestion === void 0 ? void 0 : monitorQuestion.answer) != null &&
            tryParseNumber(monitorQuestion === null || monitorQuestion === void 0 ? void 0 : monitorQuestion.answer.value) > 0
            ? monitorQuestion.answer.value
            : watchValue;
    };
    var setMonitorQuestion = function (monitorQuestion, codeName) {
        var _a;
        if (questionSet.questions && questionSet.answers) {
            var question_1 = questionSet === null || questionSet === void 0 ? void 0 : questionSet.questions.find(function (q) { return q.code == codeName; });
            if (question_1) {
                var answer = (_a = questionSet.answers) === null || _a === void 0 ? void 0 : _a.find(function (answer) {
                    return answer.formSectionQuestionId == question_1.id ? question_1.id : 0;
                });
                monitorQuestion.current = {
                    question: question_1,
                    answer: answer,
                    isPresent: true,
                };
            }
            else {
                monitorQuestion.current = {
                    question: null,
                    answer: null,
                    isPresent: false,
                };
            }
        }
    };
    var mapMonitorQuestionToAnswer = function (codeName) {
        switch (codeName) {
            case questionCodeName.purchasePrice:
                setMonitorQuestion(purchaseMonitor, questionCodeName.purchasePrice);
                break;
            case questionCodeName.loanAmount:
                setMonitorQuestion(loanMonitor, questionCodeName.loanAmount);
                break;
            case questionCodeName.loanTermYrs:
                setMonitorQuestion(loanTermMonitor, questionCodeName.loanTermYrs);
                break;
            case questionCodeName.loanTermMon:
                setMonitorQuestion(loanTermMonMonitor, questionCodeName.loanTermMon);
                break;
        }
    };
    var fetchPreviousAnswers = function () { return __awaiter(void 0, void 0, void 0, function () {
        var answers, answerData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    mapMonitorQuestionToAnswer(questionCodeName.purchasePrice);
                    mapMonitorQuestionToAnswer(questionCodeName.loanAmount);
                    mapMonitorQuestionToAnswer(questionCodeName.loanTermYrs);
                    mapMonitorQuestionToAnswer(questionCodeName.loanTermMon);
                    if (!(!purchaseMonitor.current.answer ||
                        !loanMonitor.current.answer ||
                        !loanTermMonitor.current.answer ||
                        !loanTermMonMonitor.current.answer)) return [3 /*break*/, 2];
                    return [4 /*yield*/, services.getApplicationAnswers(targetCaseId, targetFormId)];
                case 1:
                    answers = _a.sent();
                    if (answers) {
                        answerData = __assign({}, answers === null || answers === void 0 ? void 0 : answers.data);
                        if (answerData[answerCodeName.purchasePrice] && !purchaseMonitor.current.answer) {
                            setMonitorQuestion(purchaseMonitor, questionCodeName.purchasePrice);
                            purchaseMonitor.current.answer = answerData[answerCodeName.purchasePrice][0];
                        }
                        if (answerData[answerCodeName.loanAmount] && !loanMonitor.current.answer) {
                            setMonitorQuestion(loanMonitor, questionCodeName.loanAmount);
                            loanMonitor.current.answer = answerData[answerCodeName.loanAmount][0];
                        }
                        if (answerData[answerCodeName.mortgageTerm] && !loanTermMonitor.current.answer) {
                            setMonitorQuestion(loanTermMonitor, questionCodeName.loanTermYrs);
                            loanTermMonitor.current.answer = answerData[answerCodeName.mortgageTerm][0];
                        }
                        if (answerData[answerCodeName.loanTermMon] && !loanTermMonMonitor.current.answer) {
                            setMonitorQuestion(loanTermMonMonitor, questionCodeName.loanTermMon);
                            loanTermMonMonitor.current.answer = answerData[answerCodeName.loanTermMon][0];
                        }
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var findMonitorQuestionAndSetValue = function (monitorQuestion) {
        if (!!(monitorQuestion === null || monitorQuestion === void 0 ? void 0 : monitorQuestion.isPresent)) {
            hasFilterQuestion.current = true;
            return setWatchValue(id, monitorQuestion.question);
        }
    };
    var fetchDynamicProductList = function () {
        var freshWatchLoan = findMonitorQuestionAndSetValue(loanMonitor.current);
        var freshWatchPurchase = findMonitorQuestionAndSetValue(purchaseMonitor.current);
        var freshWatchLoanTerm = findMonitorQuestionAndSetValue(loanTermMonitor.current);
        var freshWatchloanTermMon = findMonitorQuestionAndSetValue(loanTermMonMonitor.current);
        if (!hasFilterBeenUsed(freshWatchLoan, freshWatchPurchase, freshWatchLoanTerm, freshWatchloanTermMon)) {
            services
                .getDynamicProductList(targetCaseId, targetFormId, targetLoanPurposeId, tryParseNumber(getAnswer(loanMonitor.current, freshWatchLoan)), tryParseNumber(getAnswer(purchaseMonitor.current, freshWatchPurchase)), tryParseNumber(getAnswer(loanTermMonitor.current, freshWatchLoanTerm)), tryParseNumber(getAnswer(loanTermMonMonitor.current, freshWatchloanTermMon)))
                .then(function (response) {
                var _a;
                setItems((_a = response.data['PRODUCT']) !== null && _a !== void 0 ? _a : []);
                productFilters.current = createProductFilters(freshWatchLoan, freshWatchPurchase, freshWatchLoanTerm, freshWatchloanTermMon);
            })
                .catch(function () { return setItems([]); });
        }
    };
    if (!!productQuestion) {
        watchLoan = !watchLoan ? findMonitorQuestionAndSetValue(loanMonitor.current) : watchLoan;
        watchPurchase = !watchPurchase ? findMonitorQuestionAndSetValue(purchaseMonitor.current) : watchPurchase;
        watchLoanTerm = !watchLoanTerm ? findMonitorQuestionAndSetValue(loanTermMonitor.current) : watchLoanTerm;
        watchLoanTermMon = !watchLoanTermMon
            ? findMonitorQuestionAndSetValue(loanTermMonMonitor.current)
            : watchLoanTermMon;
    }
    var debounceProductList = useRef(debounce(fetchDynamicProductList, 1000));
    useEffect(function () {
        fetchPreviousAnswers();
    }, []);
    useEffect(function () {
        if (productQuestion && hasFilterQuestion.current) {
            debounceProductList.current();
        }
    }, [watchLoan, watchPurchase, watchLoanTerm, watchLoanTermMon]);
    var areQuestionsDirty = isDirty(loanMonitor === null || loanMonitor === void 0 ? void 0 : loanMonitor.current, watchLoan) ||
        isDirty(purchaseMonitor === null || purchaseMonitor === void 0 ? void 0 : purchaseMonitor.current, watchPurchase) ||
        isDirty(loanTermMonitor === null || loanTermMonitor === void 0 ? void 0 : loanTermMonitor.current, watchLoanTerm) ||
        isDirty(loanTermMonMonitor === null || loanTermMonMonitor === void 0 ? void 0 : loanTermMonMonitor.current, watchLoanTermMon);
    return (React.createElement(React.Fragment, null,
        React.createElement(InputSelectProduct, { id: id, options: areQuestionsDirty && hasFilterQuestion.current ? items : displayOptions, forceSelection: forceSelection, error: error, setValue: setValue, required: required, value: value, ref: ref, onChange: inputListChangeHandler, disabled: disabled, productValue: productValue }),
        (hasFilterQuestion.current &&
            ((areQuestionsDirty && items.length == 0) || (!areQuestionsDirty && displayOptions.length == 0))) ||
            (!hasFilterQuestion.current && displayOptions.length == 0) ? (React.createElement("span", { className: "c-question-set__error-text" }, "There are no products available for the criteria that you have entered. Please refer to our product information and update your purchase amount, loan amount, mortgage term or loan type to find a product that matches your criteria.")) : (React.createElement("span", null))));
});
InputProduct.displayName = 'InputProduct';
